import { gql } from '@apollo/client';
export const GET_SALVAGE_BY_ID = gql`
  query getSalvageById($id: Int!) {
    getSalvageById(id: $id) {
      salvageId
      assetNumber
      barCode
      serialNumber
      department
      businessUnit
      description1
      description2
      description3
      additionalRemarks
      additionalRemarks2
      additionalRemarks3
      salvageFormDispositionCode
      enterpriseOneDispositionCode
      location
      physicalOwner
      updateStatus
      disposalApproval
      disposalApprovalDate
      pcaApproval
      pcaApprovalDate
      psmApproval
      psmApprovalDate
      maApproval
      maApprovalDate
      condition
      heatTicket
    }
  }
`;

export const GET_EONE_ITEM_BY_EONE_ID = gql`
  query readOneById($id: Int!) {
    readOneById(id: $id) {
      id
      assetNumber
      description1
      description2
      description3
      updateStatus
      accountNumber
      additionalRemarks
      additionalRemarks2
      additionalRemarks3
      assetItemCurrentQuantity
      assetItemOriginalQuantity
      barCode
      businessUnit
      categoryCode6
      companyNumber
      dateAcquired
      department
      equipmentStatus
      itemFunction
      location
      locationDescription
      majorAccountingClass
      majorEquipmentClass
      manufacturer
      newOrUsed
      originalPurchaser
      parentNumber
      physicalOwner
      poNumber
      serialNumber
      updateDate
      updateType
      toDeptId
    }
  }
`;
